import { styled } from "styled-components";
import confirmationImage from "./confirmation_auth.svg";
import confirmationAltImage from "./confirmation_id.svg";

const CheckMark = styled.img`
  width: 200px;
  height: 200px;
  display: block;
`;

const Wrapper = styled.div``;

export interface CheckProps {
  variant?: "authentication" | "identification";
}

export function Check({ variant = "authentication" }: CheckProps): JSX.Element {
  const src =
    variant === "identification" ? confirmationAltImage : confirmationImage;
  return (
    <Wrapper>
      <CheckMark src={src} alt="" />
    </Wrapper>
  );
}
